export enum QuizType {
  DEFAULT = 'default',
  SCORM_QUIZ = 'scorm_quiz',
  ASSIGNMENT_QUIZ = 'assignment_quiz',
  POLL_QUIZ = 'poll',
  VIDEO_QUIZ = 'video'
}
